import { render, staticRenderFns } from "./AppEchartScatter.vue?vue&type=template&id=0cc8db60&"
import script from "./AppEchartScatter.vue?vue&type=script&lang=js&"
export * from "./AppEchartScatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports